import { useEffect, useState } from 'react';
import { winnerCards } from '../../data/winners';

const moreProjects = winnerCards
  .filter((winner) => winner.id !== 'winner-2016')
  .filter((winner) => {
    const media = winner.media.toLowerCase();
    return media.includes('installation') || media.includes('performance') || media.includes('sculpture');
  })
  .slice(0, 4);

export default function JenniferMoon() {
  const slides = [
    { src: '/uploads/2015/08/jmoon1.jpg', alt: 'Jennifer Moon work 1' },
    { src: '/uploads/2015/08/jmoon2.jpg', alt: 'Jennifer Moon work 2' },
    { src: '/uploads/2015/08/jmoon3.jpg', alt: 'Jennifer Moon work 3' },
    { src: '/uploads/2015/08/jmoon4.jpg', alt: 'Jennifer Moon work 4' },
    { src: '/uploads/2015/08/jmoon5.jpg', alt: 'Jennifer Moon work 5' },
    { src: '/uploads/2015/08/jmoon6.jpg', alt: 'Jennifer Moon work 6' },
    { src: '/uploads/2015/08/jmoon7.jpg', alt: 'Jennifer Moon work 7' },
    { src: '/uploads/2015/08/jmoon8.jpg', alt: 'Jennifer Moon work 8' },
  ];
  const [activeSlide, setActiveSlide] = useState(0);

  useEffect(() => {
    if (slides.length <= 1) {
      return undefined;
    }

    const intervalId = window.setInterval(() => {
      setActiveSlide((currentSlide) => (currentSlide + 1) % slides.length);
    }, 3500);

    return () => window.clearInterval(intervalId);
  }, [slides.length]);

  return (
    <section className="portfolio-item-page">
      <div className="mx-auto max-w-7xl px-5 py-10 md:px-8">
        <h1 className="subheading uppercase">Jennifer Moon</h1>

        <div className="portfolio-item-intro">
          <div className="portfolio-item-gallery">
            <div className="portfolio-item-slideshow">
              <div className="portfolio-item-slideshow-frame" aria-label="Jannifer Moon slideshow">
                {slides.map((slide, index) => (
                  <img
                    key={slide.src}
                    className={`portfolio-item-slide ${index === activeSlide ? 'portfolio-item-slide-active' : ''}`}
                    src={slide.src}
                    alt={slide.alt}
                    aria-hidden={index !== activeSlide}
                  />
                ))}
              </div>
              <div className="portfolio-item-slideshow-dots" aria-label="Slideshow progress">
                {slides.map((slide, index) => (
                  <button
                    key={slide.src}
                    type="button"
                    className={`portfolio-item-dot ${index === activeSlide ? 'portfolio-item-dot-active' : ''}`}
                    onClick={() => setActiveSlide(index)}
                    aria-label={`Show slide ${index + 1}`}
                    aria-pressed={index === activeSlide}
                  />
                ))}
              </div>
            </div>
          </div>

          <div className="portfolio-item-description">
            <p className="general-text-third" style={{ textAlign: 'left', maxWidth: 'none', marginTop: 0, color: 'var(--purple-dark)', lineHeight: '1.6', fontSize: '1.25rem', padding: '0 0' }}>2016</p>

            <p className="general-text-third" style={{ textAlign: 'left', maxWidth: 'none', marginTop: 0, color: 'var(--purple-dark)', lineHeight: '1.6', fontSize: '1rem', padding: '2rem 0 0', fontWeight: '700'}}>Juror's Statement</p>

            <p className="general-text-third" style={{ textAlign: 'left', maxWidth: 'none', marginTop: 0, color: 'var(--purple-dark)', lineHeight: '1.6', fontSize: '1rem', padding: '0 0' }}>Jennifer Moon is an artist who has made a pronounced and profound mark with the absolute commitment to her vision, sustained by immense energy and humor.  Under the umbrella of an overarching project she calls “The Revolution,” her work has taken various forms, including room-sized multi-media installations, photographs, live performance, and even a mock TED Talk, but consistently embodies a lively imagination and great appeal, as reflected by the Public Recognition Mohn Award she won for her contribution to the 2014 Made in LA biennial at the Hammer Museum. Her spirit of collaboration and participation in the art community is evidenced by her work with KCHUNG and ongoing projects with fellow artists and cultural producers in and around Los Angeles.</p>
            <p className="general-text-third" style={{ textAlign: 'left', maxWidth: 'none', marginTop: 0, color: 'var(--purple-dark)', lineHeight: '1.6', fontSize: '1rem', padding: '0 0' }}>Moon’s more recent exhibitions in Los Angeles and elsewhere see her continuing to develop her singular artistic practice. She is consistently working toward expanding her practice and ideas, and we feel it is important to support her creativity and production which often veers toward the temporal, ephemeral and conceptual. We look forward to seeing what the future holds for her and how she develops her work further with the support of the KAFA 2016 award.</p>

            <p className="general-text-third" style={{ textAlign: 'left', maxWidth: 'none', marginTop: 0, color: 'var(--purple-dark)', lineHeight: '1.6', fontSize: '1rem', padding: '3rem 0 0', fontWeight: '700' }}>Jurors</p>

            <p className="general-text-third" style={{ textAlign: 'left', maxWidth: 'none', marginTop: 0, color: 'var(--purple-dark)', lineHeight: '2', fontSize: '1rem', padding: '0 0' }}>Anne Ellegood, Senior Curator, Hammer Museum</p>

            <p className="general-text-third" style={{ textAlign: 'left', maxWidth: 'none', marginTop: 0, color: 'var(--purple-dark)', lineHeight: '2', fontSize: '1rem', padding: '0 0' }}>Christine Y. Kim, Associate Curator of Contemporary Art, Los Angeles County Museum of Art</p>

            <p className="general-text-third" style={{ textAlign: 'left', maxWidth: 'none', marginTop: 0, color: 'var(--purple-dark)', lineHeight: '2', fontSize: '1rem', padding: '0 0' }}>John Tain, Curator for Modern and Contemporary Collections, Getty Research Institute</p>

            <p className="general-text-third" style={{ textAlign: 'left', maxWidth: 'none', marginTop: 0, color: 'var(--purple-dark)', lineHeight: '1.6', fontSize: '1rem', padding: '3rem 0 0', fontWeight: '700' }}>Biography</p>

            <p className="general-text-third" style={{ textAlign: 'left', maxWidth: 'none', marginTop: 0, color: 'var(--purple-dark)', lineHeight: '1.6', fontSize: '1rem', paddingBottom: '2rem' }}>After Jennifer Moon (b. 1973 Lafayette, Indiana) was incarcerated for nine months in 2008 and 2009 for attempted robbery, she transformed her artistic practice. Moon began turning inward, drawing from her experiences in creating the Revolution, a movement that envisions a worldwide shift in thinking through love, presence of mind, and empowerment. Blending political theory, self-help, and fantasy, Moon uses the Revolution in performances, videos, writing, and sculpture to share her unconventional vision with the world.</p>
            <p className="general-text-third" style={{ textAlign: 'left', maxWidth: 'none', marginTop: 0, color: 'var(--purple-dark)', lineHeight: '1.6', fontSize: '1rem', paddingBottom: '2rem' }}>Examples of Moon’s practice are the texts and photographs that make up the core of her self-published book This Is Where I Learned of Love. In the book, Moon casts herself as a political prisoner, merging her letters with a larger insight about prison populations in the United States. In blurring definitions and practices, Moon creates a space for shifting of notions about society.</p>
            <p className="general-text-third" style={{ textAlign: 'left', maxWidth: 'none', marginTop: 0, color: 'var(--purple-dark)', lineHeight: '1.6', fontSize: '1rem', paddingBottom: '2rem' }}>Additionally, Moon leads self-discovery workshops as part of her exhibitions, continues publishing writings, and hosts the radio show Adventures Within on KCHUNG. Moon aims to spread the Revolution beyond art making and one day have a Revolution foundation to offer guidance to others. At some point, she admits, the Revolution may evolve into a vocation that goes beyond art-world contexts.</p>

            <a href='http://jmoon.net/' className='nav-link'>Artist's Website</a>
          </div>
        </div>
      </div>

      <section className="portfolio-item-more-projects w-full" aria-labelledby="more-projects-heading">
        <div className="mx-auto max-w-7xl px-5 md:px-8">
          <h2 className="subheading" id="more-projects-heading" style={{ marginBottom: '1.5rem' }}>
            More projects
          </h2>
        </div>

        <div className="winners-grid portfolio-item-more-grid">
          {moreProjects.map((winner) => (
            <a
              key={winner.id}
              href={winner.href}
              className="winner-card"
              aria-label={`${winner.year} ${winner.media} by ${winner.name}`}
            >
              <img className="winner-card-image" src={winner.image} alt="" />
              <div className="winner-card-overlay">
                <div className="winner-card-portrait-wrap">
                  <img className="winner-card-portrait" src={winner.portrait} alt="" />
                </div>
                <div className="winner-card-copy">
                  <span className="winner-card-meta">
                    {winner.year} | {winner.media}
                  </span>
                  <span className="winner-card-name">{winner.name}</span>
                </div>
              </div>
            </a>
          ))}
        </div>
      </section>
    </section>
  );
}
